import React from 'react'
import { string, bool } from 'prop-types'
import { Field } from 'formik'
import InputMask from 'react-input-mask'
import classnames from 'classnames'

const phoneNumberMask = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
]

const phoneNumberMaskHI = [
    '+',
    /\d/,
    ' ',
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
]

const PhoneMaskedInputField = props => {
    const { hasError, className, fieldName, disableFormik, isDisabled } = props
    const customClassName = classnames(
        'masked-phone-number-input',
        {
            errorLine: hasError,
        },
        className
    )
    const mask = props.contactUs ? '(999)999-9999' : '(999)999-9999'
    if (disableFormik && props?.value !== undefined) {
        return (
            <InputMask
                value={props.value}
                mask={mask}
                onChange={e => props.onChange(e.target.value)}
                disabled={isDisabled}
            >
                {inputProps => (
                    <input
                        {...inputProps}
                        id="phone_number"
                        type="tel"
                        className={customClassName}
                        placeholder="(123)555-5555"
                        aria-label="phone number"
                    />
                )}
            </InputMask>
        )
    }
    return (
        <Field name={fieldName}>
            {({ field }) => (
                <InputMask
                    {...field}
                    mask={mask}
                    disabled={isDisabled}
                >
                    {inputProps => (
                        <input
                            {...inputProps}
                            id="phone_number"
                            type="tel"
                            className={customClassName}
                            placeholder="(123)555-5555"
                            aria-label="phone number"
                        />
                    )}
                </InputMask>
            )}
        </Field>
    )
}

PhoneMaskedInputField.propTypes = {
    fieldName: string,
    className: string,
    hasError: bool,
    disableFormik: bool,
}

PhoneMaskedInputField.defaultProps = {
    fieldName: 'phone_number',
    disableFormik: false,
}

export default PhoneMaskedInputField
